/**
 * Object helper to user authentication
 */
export default {
  /**
   * Look into dataset of header to see if user is logged in
   */
  isLoggedIn() {
    const menuWrapper = document.querySelector('.menu-mobile-wrapper');
    if (!menuWrapper) {
      return false;
    }
    return !!menuWrapper.dataset.user;
  },
  /**
   * If user is auth, returns json with id and email
   *
   * @returns null|{}
   */
  getUser() {
    const menuWrapper = document.querySelector('.menu-mobile-wrapper');
    if (!menuWrapper?.dataset?.user) {
      return null;
    }

    return JSON.parse(menuWrapper.dataset.user);
  },
  isImpersonated() {
    const menuSelector = document.querySelector('.menu-auth');
    return menuSelector?.dataset?.isimpersonated === '1';
  },
  /**
   * returns number of notifications or null
   *
   * @returns {string}
   */
  countNotifications() {
    const menuWrapper = document.querySelector('.menu-mobile-wrapper');
    return menuWrapper.dataset.notifications;
  },
};
